import { useTranslation } from 'react-i18next'

const ETAPAS = ['cadastro', 'plano', 'ordem', 'execucao', 'indicadores'] as const

/** Aba Jornada: a ordem das etapas é informação, por isso lista ordenada. */
export function AjudaJornada() {
  const { t } = useTranslation()
  return (
    <div>
      <p className="axg-ajuda-texto">{t('guidedTour.ajuda.jornada.intro')}</p>
      <ol className="axg-ajuda-lista" data-testid="ajuda-jornada-lista">
        {ETAPAS.map((etapa) => (
          <li key={etapa} className="axg-ajuda-cartao" data-testid={`ajuda-etapa-${etapa}`}>
            <div>
              <p className="axg-ajuda-item-titulo">{t(`guidedTour.ajuda.jornada.etapas.${etapa}.titulo`)}</p>
              <p className="axg-ajuda-texto">{t(`guidedTour.ajuda.jornada.etapas.${etapa}.texto`)}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  )
}
